export enum GlobalMyAccountFinHubRoutes {
  BASE = 'myaccount-financialhub',
  ORDERS = 'orders',
  QUOTES = 'quotes',
  CONSUMABLE_REPORTING = 'consopass-reporting'
}
